import AssistantHeader from './AssistantHeader';
export default AssistantHeader;
